import React from 'react'
import { Images } from '../../../utils/imageConstants'
import type { FileWithKey } from '../types'
import FileCard from './FileCard'

interface SearchBarProps {
  searchQuery: string
  selectedFiles: FileWithKey[]
  onSearchChange: (value: string) => void
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onMediaClick: () => void
  onSendMessage: () => void
  onRemoveFile: (index: number) => void
  getFileIcon: (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other') => string
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  selectedFiles,
  onSearchChange,
  onKeyPress,
  onMediaClick,
  onSendMessage,
  onRemoveFile,
  getFileIcon
}) => {
  return (
    <div className="statgpt-search-bar">
      {selectedFiles.length > 0 && (
        <div className="statgpt-file-cards-container">
          {selectedFiles.map((fileWithKey, index) => (
            <FileCard
              key={index}
              fileWithKey={fileWithKey}
              index={index}
              getFileIcon={getFileIcon}
              onRemove={onRemoveFile}
            />
          ))}
        </div>
      )}
      
      <div className="statgpt-search-input-row">
        <div className="statgpt-search-input-wrapper">
          <button 
            className="statgpt-media-button" 
            aria-label="Select files"
            onClick={onMediaClick}
          >
            <img src={Images.media_open_icon} alt="Media" />
          </button>

          <input
            type="text"
            className="statgpt-search-input"
            placeholder="Ask Anything..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyPress={onKeyPress}
          />
        </div>
        <div className="statgpt-search-trailing">
          <button 
            className="statgpt-mic-button" 
            aria-label={(searchQuery.trim() || selectedFiles.length > 0) ? "Send message" : "Voice input"}
            onClick={(searchQuery.trim() || selectedFiles.length > 0) ? onSendMessage : undefined}
          >
            <div className="statgpt-mic-icon">
              {(searchQuery.trim() || selectedFiles.length > 0) && (
                <img 
                  src={Images.send_mess_icon} 
                  alt="Send" 
                />
              )}
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default SearchBar

